import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/** tailwind-merge that knows about our custom font sizes (text-2xs, text-md) so they are not mistaken for colours. */
const twMerge = extendTailwindMerge({
  extend: {
    theme: {
      text: ["2xs", "md"],
    },
  },
});

/** Merge class names, letting later Tailwind classes override earlier ones. */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
